module.exports = __webpack_public_path__ + "media/images/ambassador_banner-7b1c1e6cd098c61bebe7d75116446a55.jpg";